import React, { PureComponent } from 'react';
import ReactSVG from 'react-svg';

import editIcon from 'appSrc/assets/img/edit_filled.svg';

export default class Edit extends PureComponent {
    render() {
        return (
            <ReactSVG src={ editIcon } style={ this.props.style } />
        );
    }
}
